import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Integration } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { IntegrationDataGrid } from './integration-data-grid';
import { IntegrationDetailsForm } from './integration-details-form';
import { IntegrationExecutionsGrid } from './integration-executions-grid';
import { IntegrationExternalMappingsPage } from './integration-external-mappings-page';
import { IntegrationMappingsPage } from './integration-mappings-page';
import { IntegrationUsersForm } from './integration-users-form';
import { IntegrationExportFilterPage } from './integration-export-filter-page';
import { IntegrationImportCalendarPage } from './integration-import-calendar-page';

export function IntegrationPage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [integration, setIntegration] = useState<Integration>();
  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadIntegration = useCallback(() => {
    apiClient
      .get(`integrations/${id}`)
      .then((response: any) => {
        setIntegration(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  const onIntegrationChanged = () => {
    loadIntegration();
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadIntegration();
  }, [id, loadIntegration]);

  const TabContent = (props: any) => {
    return (
      <Content style={{ backgroundColor: '#fff' }}>
        <Row>
          {props.fullWidth ? (
            <Col span={24}>{props.children}</Col>
          ) : props.large ? (
            <Col span={16} xs={24} sm={24} md={24} lg={24} xl={24} xxl={16}>
              {props.children}
            </Col>
          ) : (
            <Col span={8} xs={24} sm={24} md={12} lg={10} xl={10} xxl={8}>
              {props.children}
            </Col>
          )}
        </Row>
      </Content>
    );
  };

  return (
    <>
      <PageHeader title="Entegrasyon düzenle" subTitle={integration?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <IntegrationDetailsForm integration={integration} onSaved={onIntegrationChanged} />
            </TabContent>
          </Tabs.TabPane>
          {integration?.integrationType === 'EXPORT' && (
            <Tabs.TabPane tab="Filtreler" key="filter">
              <TabContent fullWidth={true}>
                <IntegrationExportFilterPage integration={integration} onSaved={onIntegrationChanged} />
              </TabContent>
            </Tabs.TabPane>
          )}
          {integration?.integrationType === 'IMPORT' && (
            <Tabs.TabPane tab="Takvim" key="schedule">
              <TabContent fullWidth={true}>
                <IntegrationImportCalendarPage integration={integration} />
              </TabContent>
            </Tabs.TabPane>
          )}
          <Tabs.TabPane tab="Bildirimler" key="users">
            <TabContent>
              <IntegrationUsersForm integration={integration} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Aktarımlar" key="executions">
            <TabContent fullWidth={true}>
              <IntegrationExecutionsGrid integration={integration} />
            </TabContent>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Veri tablosu" key="dataGrid">
            <TabContent fullWidth={true}>
              <IntegrationDataGrid integration={integration} />
            </TabContent>
          </Tabs.TabPane>

          {integration?.integrationType === 'IMPORT' && (
            <Tabs.TabPane tab="Eşleştirmeler" key="intmap">
              <TabContent fullWidth={true}>
                <IntegrationMappingsPage integration={integration} />
              </TabContent>
            </Tabs.TabPane>
          )}
          {integration?.integrationType === 'EXPORT' && (
            <Tabs.TabPane tab="Eşleştirmeler" key="extmap">
              <TabContent fullWidth={true}>
                <IntegrationExternalMappingsPage integration={integration} />
              </TabContent>
            </Tabs.TabPane>
          )}
        </Tabs>
      </Content>
    </>
  );
}
